<!--
================================================
Un composant affichant un warning lorsque une impersonation est en cours
Url d'accès : *

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="ImpersionationWarnComp">
      ❗️ Impersonation en cours user : <b>{{$auth.getUserSlug()}} </b>️
    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    import SentryMixin from "../mixins/SentryMixin.js";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";

    export default {
        name: 'ImpersionationWarnComp', //utile dans vue dev tool
        mixins: [
            GlobalErrorNotification,
            SentryMixin,
            InterceptorMixin
        ],
        components: {},

        data: function () {
            return {
            }
        },

        computed:{
        },


        methods: {

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #ImpersionationWarnComp{

        padding: 0.5rem;
        line-height: 1rem;
        border-bottom: solid 1px gold;
        margin: 0 0 0.8rem;
        font-size: 0.9rem;
        font-family: Courier Next, courier, monospace;
        animation: glow 0.8s infinite alternate;

        @keyframes glow {
            from {
              background: rgb(243, 188, 23);
            }
            to {
              background: gold;

            }
        }
    }
</style>
